import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { ArticlesFilteredsTypes } from "../../../models/news-articles/articles-filtered-model"
import { retrieveArticlesFiltereds397 } from "../../../redux/slice/news-articles/articles-filtered397-slice"
import { useAppDispatch, RootState } from "../../../redux/store"

type NewsAndArticleCardTypes = {
  cardSecTitle: string
  cardSecSubTitle: string
  cardSecContent: string
  cardSecInfo: string
  article: ArticlesFilteredsTypes[]
}



const DepartmentsSliderCard397 = (props: NewsAndArticleCardTypes) => {

  const ArticlesFilteredsData397 = props.article


  return <div className={`feature-single ${props.cardSecTitle}`}>
    <Link to='/news-and-articles/news-articles?category=397'>
      <div className={props.cardSecSubTitle}>
        Recon
      </div>
    </Link>
    <Link to={ArticlesFilteredsData397[0]?.articlesList[0]?.articleUrl}>
      <img src={ArticlesFilteredsData397[0]?.articlesList[0]?.articleTeaserImage} alt={ArticlesFilteredsData397[0]?.articlesList[0]?.articleName} loading="lazy" />
    </Link>
    <div className={props.cardSecContent}>
      <div className={props.cardSecInfo} >
        <ul>
          {
            (ArticlesFilteredsData397[0]?.articlesList?.length > 1) ? (
              <>
                {
                  ArticlesFilteredsData397[0]?.articlesList.map((item, index) => {
                    return <li key={index}>
                      <Link to={item.articleUrl} dangerouslySetInnerHTML={{ __html: item.articleName }}></Link>
                    </li>
                  })
                }
                <li>
                  {
                    (ArticlesFilteredsData397[0]?.articlesList.length > 1) && <Link to='/news-and-articles/news-articles?category=397' className="view-more">See more</Link>
                  }
                </li>
              </>

            ) : (
              <li>
                <Link to={ArticlesFilteredsData397[0]?.articlesList[0].articleUrl} dangerouslySetInnerHTML={{ __html: ArticlesFilteredsData397[0]?.articlesList[0]?.articleName }}></Link>
                <p dangerouslySetInnerHTML={{ __html: ArticlesFilteredsData397[0]?.articlesList[0]?.articleTeaserText }}></p>
              </li>
            )
          }
        </ul>

      </div>
    </div>
    {

    }
  </div>
}

export default DepartmentsSliderCard397
